import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../constants";

/** Gallery stand-in for minting the cash-deposit magic link. */
const GALLERY_MINT_MS = 1400;

/**
 * Gallery-safe cash-deposit launch: sweep the pending row, then hand off to
 * the cash-deposit landing (no “Preparing your deposit…” page).
 */
export function useGalleryCashDepositLaunch(options?: { frozen?: boolean }) {
  const navigate = useNavigate();
  const frozen = Boolean(options?.frozen);
  const [payingOperationId, setPayingOperationId] = useState<string | null>(
    null
  );
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current != null) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, []);

  const launch = useCallback(
    (operationId: string) => {
      if (frozen || payingOperationId) return;
      setPayingOperationId(operationId);
      timerRef.current = window.setTimeout(() => {
        navigate(APP_ROUTES.CASH_DEPOSIT_LANDING_PAGE);
      }, GALLERY_MINT_MS);
    },
    [frozen, payingOperationId, navigate]
  );

  return { launch, payingOperationId };
}
